package com.eladfinish.bible.contest.network

import com.eladfinish.bible.contest.appcontent.AppLinks

class RemoteApiBaseUrlProvider : ApiBaseUrlProvider {
    override fun getBaseUrl(): String = AppLinks.API_SERVER_URL
}

@Suppress("unused")
class RemoteDevApiBaseUrlProvider : ApiBaseUrlProvider {
    override fun getBaseUrl(): String = "https://dev-your-server-url.com"
}

@Suppress("unused")
class ProdApiBaseUrlProvider : ApiBaseUrlProvider {
    override fun getBaseUrl(): String = "https://api.harishon.example.com"
}

@Suppress("unused")
class LocalApiBaseUrlProvider : ApiBaseUrlProvider {
    override fun getBaseUrl(): String {
        return "http://10.100.102.21:8080"
    }
}
